import WebLogger from "@/domain/logger/WebLogger.js";

export function useLog() {
  const log = new WebLogger(window.console, true);
  return { log };
}
